import React from "react";

export default class Box extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { children, title } = this.props;
    return (
      <div
        className="jarviswidget jarviswidget-sortable"
        id="customer-wid-id-0"
        data-widget-colorbutton="false"
        data-widget-editbutton="false"
        data-widget-custombutton="false"
        role="widget"
        style={{ marginBottom: "10px"}}
      >
        <header role="heading" className="ui-sortable-handle">
          <h2>
            <b>{title}</b>
          </h2>
          <span className="jarviswidget-loader">
            <i className="fa fa-refresh fa-spin"></i>
          </span>
        </header>
        <div role="content">
          <div className="jarviswidget-editbox"></div>
          <div className="widget-body no-padding">
            <div className="smart-form" style={{ padding: "2px 0px" }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
